import moment from 'moment';

export default class Projeto {
  constructor(
    IdProjeto = null,
    Projeto = '',
    Status = 'A',
    IdSituacao = 44,
    Situacao = 'INICIAL',
    IdModeloProjeto = 1,
    ModeloProjeto = 'PROJETO',
    IdTipoProjeto = 1,
    TipoProjeto = 'TIPO PROJETO',
    Observacoes = '',
    DataEmissao = moment.utc().toISOString(),
    DataPrevisao = moment.utc().toISOString(),
    DataFinalizacao = null,
    IdCliente = null,
    Fantasia = '',
    Numero = null,
    IdResponsavel = JSON.parse(localStorage.getItem('user')).IdColaborador,
    Responsavel = JSON.parse(localStorage.getItem('user')).Colaborador,
    Objetivo = '',
    Escopo = '',
    Requisito = '',
    Risco = '',
    Responsabilidade = '',
    DuracaoLimite = new Date(1970, 0, 1, 0, 0, 0)
  ) {
    this.IdProjeto = IdProjeto;
    this.Projeto = Projeto;
    this.Status = Status;
    this.IdSituacao = IdSituacao;
    this.Situacao = Situacao;
    this.IdModeloProjeto = IdModeloProjeto;
    this.ModeloProjeto = ModeloProjeto;
    this.IdTipoProjeto = IdTipoProjeto;
    this.TipoProjeto = TipoProjeto;
    this.Observacoes = Observacoes;
    this.DataEmissao = DataEmissao;
    this.DataPrevisao = DataPrevisao;
    this.DataFinalizacao = DataFinalizacao;
    this.IdCliente = IdCliente;
    this.Fantasia = Fantasia;
    this.Numero = Numero;
    this.IdResponsavel = IdResponsavel;
    this.Responsavel = Responsavel;
    this.Objetivo = Objetivo;
    this.Escopo = Escopo;
    this.Requisito = Requisito;
    this.Risco = Risco;
    this.Responsabilidade = Responsabilidade;
    this.DuracaoLimite = DuracaoLimite;
  }
}